import React from 'react';
import { Loading } from '@avila-tek/ui/src';
import { useQuery } from '@apollo/client';
import { COMPANIES } from '../../graphql/queries';
import { Company } from '../../models';

export default function Allies() {
  const { data: dataCompany, loading } = useQuery<{ companies: Company[] }>(
    COMPANIES,
    {
      variables: {
        filter: {
          active: true,
        },
      },
      fetchPolicy: 'network-only',
    }
  );

  return (
    <div className="flex flex-col w-full items-center px-20 mt-10 min-h-full">
      <div className="flex flex-row w-full">
        <p className="text-xl lg:text-2xl text-color-primary-text-300 font-semibold my-5">
          NUESTROS ALIADOS
        </p>
      </div>
      {loading ? (
        <div className="flex flex-row justify-center items-center">
          <Loading />
        </div>
      ) : (
        <div className="flex flex-col w-full overflow-x-auto">
          <ul className="flex flex-row gap-x-2 items-start justify-start w-full overflow-x-auto overflow-y-hidden scrollbar-thin scrollbar-track-color-primary-200 scrollbar-thumb-color-primary-300">
            {dataCompany?.companies.map((item, index) => (
              <li
                key={index}
                className="flex flex-auto flex-col w-32 h-32 flex-shrink-0 my-2"
              >
                <img
                  alt="logo"
                  src={item?.logo?.src ?? '/images/meitBoxesColor.png'}
                  className="w-32 h-32 object-cover object-center"
                />
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
